import { request } from './request'
import axios from 'axios'
import configs from '@/config/config'
import store from '../store'
import { encrypt } from '../utils/sm4Util'
import { fullDate } from "../utils/tools"

var requestUrl = process.env.NODE_ENV === 'production' ? baseUrl : configs.baseUrl;
const userApi = {
  //注册
  register: params => {
    let params2 = {
      username: params.username,
      password: params.password,
      code: params.code
    }
    return request({ method: 'POST', url: '/UsersApi/Register', params: params2 });
  },
  registerNew: params => {
    return request({ method: 'POST', url: '/UsersApi/Register', params: params });
  },
  // 注销用户
  deleteUser: id => {
    return request({ url: "UsersApi/DeleteUser", params: { id: id } })
  },
  //获取图片验证码
  getPicVerifyCode: params => {
    return request({ url: '/UsersApi/GetVerifyCode', params: params, });
  },
  //登录--用户名密码登录
  login: params => {
    return request({ url: '/UsersApi/Login', params: params });
  },
  //获取手机验证码
  getTelVerifyCode: params => {
    return request({ url: '/UsersApi/GetCode', params: params })
  },
  // 手机登录
  loginPhone: params => {
    let newParam = {
      ...params,
      type: 0,
    }
    return request({ url: "/UsersApi/LoginPhone", params: newParam })
  },

  findPwd: params => {
    // let user_id = 0;
    // if (store.state.userInfo && store.state.userInfo.id) {
    //   user_id = store.state.userInfo.id
    // }
    return request({ method: 'POST', url: "/UsersApi/FindPwd", params: params })
  },



  resetPwd: params => {
    return request({ method: 'POST', url: '/UsersApi/ResetPwd', params: params })
  },

  Upload: params => {
    // let username= params.username;
    let phone = params.phone || '';
    let config = {
      headers: { 
        'Content-Type': 'multipart/form-data',
        Chktoken: encrypt(fullDate())
      }
    }
    // 添加请求头
    return axios.post(requestUrl + '/UsersApi/Upload?phone=' + phone, params.param, config)
  },

  //获取头像
  getHeadImg: params => {
    return request({ url: '/UsersApi/GetHeadImg', params: params })
  },

  // 获取资源数据
  getShowTotal: () => {
    let user_id = 0;
    if (store.state.userInfo && store.state.userInfo.id) {
      user_id = store.state.userInfo.id
    }
    if (user_id == 0) return;
    return request({ url: "/UsersApi/GetShowTotal", params: { user_id: user_id } })
  },

  //是否有下载权限
  getIsDownload: () => {
    let user_id = 0;
    if (store.state.userInfo && store.state.userInfo.id) {
      user_id = store.state.userInfo.id
    }
    if (user_id == 0) return;
    return request({ url: "/UsersApi/GetIsDownload", params: { user_id: user_id } })
  },

  // 获取用户权限数量
  getRightCount: params => { return request({ url: "/BrowsingRecordApi/GetListCount", params }) },

  // 获取用户相关权限列表数据
  getRightList: params => { return request({ url: "/BrowsingRecordApi/GetList", params }) },

  // 获取用户授权数据
  getGrandList: params => { return request({ url: "/UsersApi/GetGrantList", params }) },

  getLoginQr: () => request({ url: "/WxApi/GetCode", params: { _: Math.ceil(Math.random() * 100000) } }),

  getLoginResult: params => { return request({ url: "/UsersApi/getLoginWx", params }) },

  getUserInfo: params => request({ url: '/UsersApi', params }),

  getWechatOpenid: params => request({ url: "/WxApi/GetScanCodeToken", params }),

  getInfoByOpenid: params => request({ url: "/UsersApi/getLoginWx", params }),
}

export default userApi